import { format } from "date-fns";

import { useGetMyActiveRequests } from "@/api/product-request";

import { Badge } from "../ui/badge";
import { Card } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

export function RequestStatusBadge({ status }: { status: "PENDING" | "ACTIVE" | "COMPLETED" | "CANCELLED" }) {
	const statusConfig = {
		pending: { label: "Pending", variant: "secondary" },
		active: { label: "Active", variant: "default" },
		completed: { label: "Completed", variant: "success" },
		cancelled: { label: "Cancelled", variant: "destructive" }
	} as const;

	const config = statusConfig[status.toLowerCase() as keyof typeof statusConfig];

	return (
		<Badge variant={config.variant}>
			{config.label}
		</Badge>
	);
}

interface RequestListProps {
	onRequestSelect?: (requestId: string) => void;
}

export function RequestList({ onRequestSelect }: RequestListProps) {
	const { data: requests, isPending } = useGetMyActiveRequests();

	if (isPending) {
		return (
			<div className="space-y-4">
				{Array.from({ length: 3 }).map(() => (
					<Card key={crypto.randomUUID()} className="p-2">
						<div className="space-y-4">
							<Skeleton className="h-4 w-3/4" />
							<Skeleton className="h-4 w-1/2" />
							<div className="flex justify-between items-center">
								<Skeleton className="size-24" />
								<Skeleton className="h-8 w-24" />
							</div>
						</div>
					</Card>
				))}
			</div>
		);
	}

	return requests?.data.data.map(request => (
		<Card
			key={request.id}
			className="p-6 shadow-none border-none hover:bg-accent/50 cursor-pointer transition-colors"
			onClick={() => onRequestSelect?.(request.id)}
		>
			<div className="space-y-2">
				<div className="flex items-start justify-between">
					<div className="space-y-1">
						<h3 className="font-medium line-clamp-2">
							{request.productDescription}
						</h3>
						<p className="text-sm text-muted-foreground">
							Created
							{" "}
							{format(new Date(request.createdAt), "MMM d, yyyy")}
						</p>
					</div>
					{/* <RequestStatusBadge status={request.status} /> */}
				</div>
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-2">
						{request.quantity && (
							<span className="text-sm text-muted-foreground">
								Quantity:
								{" "}
								{request.quantity}
							</span>
						)}
						{/* {request.preferredState && (
							<span className="text-sm text-muted-foreground">
								State:
								{" "}
								{request.preferredState}
							</span>
						)} */}
					</div>
				</div>
			</div>
		</Card>
	));
}
